import { useEffect, useMemo, useState } from "react"

import { getTranslation } from "Utils/getTranslation"
import { ensureRemoteTranslation } from "Utils/translationLoader"

/**
 * Hook qui garantit le chargement des traductions distantes pour une locale donnée
 * puis force un re-render lorsque les données distantes sont disponibles.
 */
export const useRemoteTranslation = <T = Record<string, string>>(
  languageId: unknown
): T => {
  const [version, setVersion] = useState(0)

  useEffect(() => {
    let cancelled = false
    ensureRemoteTranslation(languageId)
      .catch(() => undefined)
      .finally(() => {
        if (!cancelled) {
          setVersion(prev => prev + 1)
        }
      })
    return () => {
      cancelled = true
    }
  }, [languageId])

  return useMemo(() => getTranslation(languageId) || ({} as T), [languageId, version])
}


